import { LOGOUT_USER } from './actionTypes'
import { LogoutAction } from './types'

export const logoutUser = (): LogoutAction => ({
  type: LOGOUT_USER,
  payload: null
})
